export interface ArticleDetail {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  category: string;
  categorySlug: string;
  date: string;
  duration: string;
  views: number;
  tags: string[];
  authorName: string;
}

export const articleDetails: Record<string, ArticleDetail> = {
  'hot-1': {
    id: 'hot-1',
    title: '2026年最受期待的10部韩剧',
    excerpt: '从浪漫爱情到悬疑惊悚，今年下半年的韩剧阵容令人期待。我们精选了十部必追剧集，带你提前了解剧情亮点与主演阵容。',
    content: `2026年的韩剧市场依旧精彩纷呈。从备受期待的续集到全新原创IP，韩国各大电视台和流媒体平台都在下半年准备了丰盛的剧集大餐。

## 一、《王国》第三季

时隔两年，这部现象级丧尸古装剧终于回归。第三季将揭晓更多关于生死草的起源秘密，以及王世子李苍如何面对更加严峻的内忧外患。全智贤的加盟更是让这一季的期待值拉满。

## 二、《黑暗荣耀》编剧新作《审判者》

金恩淑编剧再次出手，这次聚焦法律与正义的主题。宋慧乔与朴宝剑首次搭档，讲述了一位检察官与一名被冤枉的囚犯之间展开的复杂故事。

## 三、《我的解放日记》编剧新作

以细腻情感著称的朴海英编剧带来了全新作品，继续探讨都市人在现代社会中的孤独与连接。这部剧被誉为"2026年最治愈的韩剧"。

## 四至十名

此外，《Signal信号》电影版也将于年底上映；改编自热门网漫的《再婚皇后》引起广泛讨论；孔刘与金泰梨合作的科幻剧《时间旅人》备受瞩目。

无论您是悬疑、浪漫还是科幻题材的爱好者，2026下半年的韩剧市场都能满足您的期待。记得关注我们的频道，第一时间获取最新剧集解读和推荐。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20drama%20film%20set%20photography%20with%20actor%20in%20traditional%20costume%2C%20dramatic%20lighting%20from%20behind%2C%20elegant%20composition%2C%20rich%20amber%20and%20deep%20crimson%20tones&width=1200&height=600&seq=article-hot-1&orientation=landscape',
    category: '日韩专区',
    categorySlug: 'japan-korea',
    date: '2026-08-10',
    duration: '45:20',
    views: 125800,
    tags: ['韩剧', '影视推荐', '2026'],
    authorName: '林雅婷',
  },
  'hot-2': {
    id: 'hot-2',
    title: '华语纪录片《山海之间》：镜头下的中国之美',
    excerpt: '这部历时三年拍摄的纪录片，以独特的视角展现了从青藏高原到东部沿海的自然奇观与人文故事，被誉为今年最值得一看的华语纪录片。',
    content: `《山海之间》是一部令人叹为观止的华语自然人文纪录片，由中国著名纪录片导演张克明执导，历时三年跨越中国全境拍摄完成。

## 拍摄背后的故事

导演张克明在接受采访时表示："我们想通过这部纪录片展现一个立体而真实的中国——不仅有壮丽的自然景观，还有生活在其中的人们的故事。"团队从青藏高原的冰川出发，一路向东，穿越戈壁沙漠、黄土高原、长江流域，最终抵达东部海岸线。

## 震撼的视听语言

《山海之间》采用了最新的8K摄影技术和无人机航拍，将中国大地的壮美展现得淋漓尽致。特别是在青藏高原部分的拍摄，团队在海拔5000米以上的极端环境中坚持了两个月，最终捕捉到了冰川融化、雪豹出没等珍贵画面。

## 人文视角的温度

与众不同的是，这部纪录片并非单纯的"风光大片"。导演刻意将镜头对准了沿途遇到的普通人——在高原上放牧的藏民、在黄土高原种苹果的农民、在长江边捕鱼的渔民。他们的故事构成了这部纪录片最动人的部分。

## 国际反响

《山海之间》在今年的多个国际纪录片电影节上斩获大奖，被《纽约时报》称为"一部重新定义中国自然纪录片的杰作"。如果你还没有观看这部作品，强烈推荐在亚洲视频精选平台上找到它。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Chinese%20landscape%20documentary%20photography%20with%20majestic%20mountains%2C%20golden%20sunrise%20over%20misty%20valley%2C%20epic%20wide%20composition%2C%20rich%20amber%20and%20emerald%20earth%20tones&width=1200&height=600&seq=article-hot-2&orientation=landscape',
    category: '华语精选',
    categorySlug: 'chinese',
    date: '2026-08-08',
    duration: '58:30',
    views: 98300,
    tags: ['纪录片', '华语', '自然'],
    authorName: '陈思远',
  },
  'hot-3': {
    id: 'hot-3',
    title: '泰国独立电影崛起：东南亚新浪潮',
    excerpt: '近年来泰国独立电影在国际电影节上屡获殊荣，一批年轻导演用独特视角讲述东南亚故事，引领了一场引人注目的电影新浪潮。',
    content: `泰国电影产业正经历一场静悄悄的革命。在国际电影节的聚光灯下，一批年轻的泰国独立导演正在用全新的电影语言讲述关于泰国的故事。

## 新浪潮的缘起

一切始于2023年。导演阿彼察邦·韦拉斯哈古的《记忆》在戛纳电影节获得评审团奖后，全球目光开始聚焦泰国独立电影。但真正的变化来自于一批更年轻的声音——他们大多出生在1990年代，成长于数字时代，拥有更加国际化的视野。

## 代表人物与作品

其中最具代表性的当属30岁的导演纳塔吾·彭皮里亚。她的长片处女作《曼谷雨季》在2025年的釜山国际电影节上引起轰动，影片以诗意的镜头语言讲述了一个在雨季曼谷发生的跨文化爱情故事。此外，擅长悬疑惊悚类型的查侬·桑提纳同、以社会现实题材著称的瓦奇拉·通颂，都在各自的领域做出了令人瞩目的成绩。

## 文化独特性

泰国独立电影的魅力在于其独特的文化表达。无论是佛教哲学对叙事结构的影响，还是泰国南方与北方截然不同的地域风貌，这些作品都展现出令人耳目一新的东南亚美学。

## 未来的挑战

尽管势头强劲，泰国独立电影仍面临资金短缺、国内市场有限等挑战。但随着流媒体平台的全球扩张和亚洲内容需求的增长，这些年轻导演的作品正在获得越来越广泛的观众群体。亚洲视频精选平台将持续关注并引入最优质的泰国独立电影，敬请期待。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Thai%20indie%20film%20director%20working%20on%20set%20photography%20in%20Bangkok%20streets%2C%20tropical%20evening%20lighting%2C%20artistic%20composition%2C%20rich%20golden%20amber%20and%20neon%20accent%20tones&width=1200&height=600&seq=article-hot-3&orientation=landscape',
    category: '东南亚',
    categorySlug: 'southeast-asia',
    date: '2026-08-06',
    duration: '30:15',
    views: 76200,
    tags: ['独立电影', '泰国', '东南亚'],
    authorName: '王浩宇',
  },
  'hot-4': {
    id: 'hot-4',
    title: '日本动漫2026夏季新番全面解读',
    excerpt: '夏季新番陆续开播，从热血战斗到治愈日常，本季动漫阵容丰富多样。我们为你梳理了最值得关注的十部新番作品。',
    content: `2026年夏季新番季正式拉开帷幕，本季的动画阵容堪称近年来最强。从备受期待的续作到原创黑马，让我们一起来看看有哪些作品值得追。

## 续作大作

《咒术回战》第三季无疑是本季最大焦点。涉谷事变之后，剧情进入全新篇章，制作质量再次升级。MAPPA工作室投入了空前的制作资源，每一集的动作场面都堪比剧场版水准。

《间谍过家家》第二季后半部分也将在七月回归。福杰一家的温馨日常与谍战主线并行推进，安妮亚的校园生活也将迎来新的挑战。

## 黑马原创

本季最令人惊喜的莫过于原创动画《星之航路》。这部由新锐导演佐藤健一执导的科幻作品，讲述了一位少女在星际货运飞船上寻找失踪父亲的冒险故事。首播三集后豆瓣评分高达9.2。

## 异世界与轻改

异世界题材依旧强势。《最强魔法师的慢生活》以其独特的日常系异世界设定获得了大量好评，而《转生成为魔王的我决定摆烂》则以反套路剧情吸引了众多观众。

## 推荐观看顺序

如果你时间有限，我们推荐优先观看：《咒术回战》第三季 > 《星之航路》 > 《间谍过家家》第二季 > 《最强魔法师的慢生活》。完整的剧情解读和每集评论，请持续关注亚洲视频精选平台。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20anime%20art%20illustration%20with%20vibrant%20color%20palette%2C%20dynamic%20action%20scene%2C%20stylized%20composition%2C%20rich%20warm%20amber%20and%20electric%20accent%20colors&width=1200&height=600&seq=article-hot-4&orientation=landscape',
    category: '日韩专区',
    categorySlug: 'japan-korea',
    date: '2026-08-05',
    duration: '40:00',
    views: 156400,
    tags: ['动漫', '新番', '日本'],
    authorName: '林雅婷',
  },
  'hot-5': {
    id: 'hot-5',
    title: '新加坡本土综艺：多元文化的趣味碰撞',
    excerpt: '新加坡综艺节目以其多元文化特色独树一帜，融合中华、马来、印度等文化元素，创造出别具一格的娱乐体验。',
    content: `新加坡虽然国土面积不大，但其综艺节目却以其独特的多元文化融合特色在亚洲综艺市场中占有独特位置。

## 文化的熔炉

新加坡的人口构成包括华人、马来人、印度人等多个族群，这种多元文化背景为综艺节目提供了丰富的创作素材。例如热门节目《舌尖上的种族和谐》就让来自不同族裔的嘉宾一起烹饪各自文化的代表性美食，在轻松的氛围中探讨文化差异与融合。

## 语言特色的魅力

新加坡综艺的另一大特色是语言的混搭使用。主持人和嘉宾常常在英语、华语、马来语和方言之间自由切换，这种独特的"新加坡式"表达方式本身就极具娱乐性。

## 代表性的节目

《邻里故事》是一档深入新加坡各个社区的真人秀节目，每集探访一个组屋区，了解当地居民的生活故事；《食在四方》则是一档以美食为载体的文化交流节目，展现了新加坡作为"美食天堂"的独特魅力。

## 走向国际

近年来，新加坡综艺节目开始借助Netflix等国际平台走向全球。像《新加坡社交厨房》这样的节目已经被翻译成多种语言，让更多国际观众了解到这个东南亚城市国家独特的文化魅力。

在新加坡综艺节目中，你总能看到不同文化之间的碰撞与融合，这正是新加坡最迷人的地方。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Singapore%20variety%20show%20studio%20photography%20with%20multicultural%20hosts%2C%20colorful%20set%20design%2C%20vibrant%20lighting%2C%20rich%20golden%20amber%20and%20tropical%20accent%20tones&width=1200&height=600&seq=article-hot-5&orientation=landscape',
    category: '综艺娱乐',
    categorySlug: 'variety',
    date: '2026-08-03',
    duration: '28:50',
    views: 54100,
    tags: ['综艺', '新加坡', '多元文化'],
    authorName: '陈思远',
  },
  'hot-6': {
    id: 'hot-6',
    title: '韩国独立音乐纪录片：K-Indie的声音地图',
    excerpt: '从弘大的地下俱乐部到济州岛的海边音乐节，这部纪录片追踪了韩国独立音乐人的创作旅程，呈现K-Pop之外的另一种音乐风景。',
    content: `在K-Pop的耀眼光芒背后，韩国独立音乐正在悄然生长。这部纪录片《K-Indie的声音地图》首次全面展示了韩国独立音乐圈的生态。

## 弘大——独立音乐的起点

纪录片从首尔弘大出发。这里曾是韩国独立音乐的发源地，无数乐队在地下俱乐部中诞生。影片采访了多位在弘大起步的音乐人，包括已成名的乐队Hyukoh的主唱吴赫，以及正在崭露头角的新人。

## 从首尔到济州

镜头跟随几位音乐人的巡演路线，从首尔到釜山，再到济州岛。在济州的海边音乐节上，独立音乐人们找到了与自然融为一体的表演方式。这些场景的拍摄极富诗意。

## 独立与主流的边界

纪录片也探讨了一个有趣的现象：越来越多的独立音乐人开始与主流K-Pop产业合作。独立乐队在偶像歌手的专辑中担任制作人，或者为偶像团体创作歌曲，这种跨界合作为双方都带来了新的可能性。

## 观众反响

《K-Indie的声音地图》在韩国独立电影院上映后获得了极高评价，被誉为"韩国音乐纪录片的新高度"。对于想要了解K-Pop之外的韩国音乐世界的观众来说，这是一部不可错过的作品。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20indie%20music%20live%20performance%20photography%20in%20intimate%20club%20setting%2C%20red%20and%20blue%20stage%20lighting%2C%20moody%20atmosphere%2C%20rich%20amber%20and%20deep%20shadow%20tones&width=1200&height=600&seq=article-hot-6&orientation=landscape',
    category: '纪录短片',
    categorySlug: 'documentary',
    date: '2026-08-01',
    duration: '55:00',
    views: 68700,
    tags: ['纪录片', '音乐', '韩国'],
    authorName: '王浩宇',
  },
};